import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class LayoutService {

    constructor(
        @Inject(DOCUMENT) private document: Document
    ) {


    }

    showFooter(): void {

        const footer = this.document.getElementById('tf-global-footer');

        if (footer) {
            footer.style.display = 'block';
        }

    }


}
